<div>
    <form [formGroup]="entityBranchForm">
        <mat-card class="branch-form-card">
            <div class="tab-group-wrapper">
                <!-- Toggles floated to the right of the tab header row -->
                <div class="tab-header-actions">
                    <mat-hint style="color: red;">{{message}}</mat-hint>
                    <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked" [ngModelOptions]="{standalone: true}" *ngIf="showDeactivateToggle && id">Deactivate Branch</mat-slide-toggle>
                    <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked" [ngModelOptions]="{standalone: true}" *ngIf="showReactivateToggle && id">Reactivate Branch</mat-slide-toggle>
                </div>

            <mat-tab-group animationDuration="0ms" class="branch-inner-tab-group" mat-stretch-tabs="false">

                <!-- Sub-tab 1: Branch Details -->
                <mat-tab label="Branch Details">
                    <mat-card-content>
                        <div class="branch-details-row">
                            <mat-form-field appearance="fill" class="branch-code-field">
                                <mat-label>Branch Code</mat-label>
                                <input matInput placeholder="Auto-generated" autocomplete="off" formControlName="code" readonly>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="branch-name-field">
                                <mat-label>Branch Name</mat-label>
                                <input matInput placeholder="Branch Name" autocomplete="off" formControlName="name" required maxlength="60"
                                   (blur)="trimControl(name)">
                                <mat-error *ngIf="name.touched && name.hasError('required') && name.invalid">Branch Name is required</mat-error>
                                <mat-error *ngIf="name.touched && name.hasError('maxlength') && name.invalid">Branch Name should not be more than 60 characters</mat-error>
                                <mat-error *ngIf="name.touched && name.hasError('pattern') && name.invalid">Special characters are not allowed.</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="branch-type-field">
                                <mat-label>Branch Type</mat-label>
                                <mat-select formControlName="branchType" placeholder="Select Branch Type" required
                                            (selectionChange)="onBranchTypeChange($event.value)">
                                    <mat-option *ngFor="let type of branchTypeList" [value]="type.key">{{type.label}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="branchType.touched && branchType.hasError('required') && branchType.invalid">Branch Type is required</mat-error>
                            </mat-form-field>
                            <!-- Branch Landline No. -->
                            <mat-form-field appearance="fill" floatLabel="always" class="branch-landline-field">
                            <mat-label>Branch Landline No.</mat-label>
                            <mat-chip-grid #chipList>
                                <mat-chip-row *ngFor="let item of getNumber(); let i = index;"
                                    [removable]="!disableSubmit" (removed)="removeNumber(i)">
                                    {{item}}
                                    <mat-icon matChipRemove *ngIf="!disableSubmit">cancel</mat-icon>
                                </mat-chip-row>
                                <input placeholder="Type and press Enter..." autocomplete="off"
                                       [matChipInputFor]="chipList"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       [matChipInputAddOnBlur]="true"
                                       [disabled]="disableSubmit"
                                       (matChipInputTokenEnd)="addNumber($event)"/>
                            </mat-chip-grid>
        
                        </mat-form-field>
                        </div>

                        <!-- Address: Branch Address textarea + Country/State/City/Location/ZIP/Landmark -->
                        <app-address [addressConfig]="addressConfig" [country]="countryId" [disableSubmit]="disableSubmit"
                                     [addressLabel]="'Branch Address'" [addressMaxLength]="500">
                        </app-address>

                    </mat-card-content>

                    <!-- SEZ Status row -->
                    <mat-card-content class="sez-status-row">
                        <mat-form-field appearance="fill" class="sez-status-field">
                            <mat-label>SEZ Status</mat-label>
                            <mat-select formControlName="sez">
                                <mat-option [value]="false">No</mat-option>
                                <mat-option [value]="true">Yes</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <ng-container *ngIf="sez.value === true">
                            <mat-form-field appearance="fill" class="date">
                                <mat-label>SEZ Certificate WEF</mat-label>
                                <input matInput [matDatepicker]="sezWefPicker" formControlName="sezWEFDate"
                                       placeholder="DD/MM/YYYY" required autocomplete="off"
                                       [max]="sezValidUptoDate.value">
                                <mat-datepicker-toggle matSuffix [for]="sezWefPicker" [disabled]="disableSubmit"></mat-datepicker-toggle>
                                <mat-datepicker #sezWefPicker></mat-datepicker>
                                <mat-error *ngIf="sezWEFDate.hasError('required') && sezWEFDate.touched">WEF date is required</mat-error>
                                <mat-error *ngIf="sezWEFDate.hasError('matDatepickerMax') && sezWEFDate.touched">WEF must be before Upto date</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="date">
                                <mat-label>SEZ Certificate Upto</mat-label>
                                <input matInput [matDatepicker]="sezUtoPicker" formControlName="sezValidUptoDate"
                                       placeholder="DD/MM/YYYY" required autocomplete="off"
                                       [min]="sezWEFDate.value">
                                <mat-datepicker-toggle matSuffix [for]="sezUtoPicker" [disabled]="disableSubmit"></mat-datepicker-toggle>
                                <mat-datepicker #sezUtoPicker></mat-datepicker>
                                <mat-error *ngIf="sezValidUptoDate.hasError('required') && sezValidUptoDate.touched">Upto date is required</mat-error>
                                <mat-error *ngIf="sezValidUptoDate.hasError('matDatepickerMin') && sezValidUptoDate.touched">Upto must be after WEF date</mat-error>
                            </mat-form-field>

                            <div class="upload-inline">
                                <span class="upload-label">Upload SEZ Certificate <span style="color:red">*</span></span>
                                <input type="file" hidden #sezFileInput accept=".pdf,.jpg,.jpeg,.png"
                                       (change)="filesSelected($event.target['files'])"/>
                                <mat-icon class="__upload_icon" style="cursor: pointer; color: green;"
                                          *ngIf="!(sezDocument || sezFileName)"
                                          (click)="!disableSubmit && sezFileInput.click()">cloud_upload</mat-icon>
                                <div class="uploaded-file-cell" *ngIf="sezDocument || sezFileName">
                                  <mat-icon class="uploaded-icon">cloud_done</mat-icon>
                                  <span class="uploaded-file-name" [matTooltip]="sezFileName">{{ sezFileName }}</span>
                                  <mat-icon class="preview-icon" matTooltip="Preview" (click)="previewSezFile()">visibility</mat-icon>
                                  <mat-icon class="download-icon" matTooltip="Download" (click)="downloadFile()">file_download</mat-icon>
                                  <mat-icon class="reupload-icon" *ngIf="!disableSubmit" matTooltip="Replace" (click)="sezFileInput.click()">cloud_upload</mat-icon>
                                </div>
                            </div>
                        </ng-container>
                    </mat-card-content>
                <!-- Business Segment Wise Sales & CS Mapping  -->
                <mat-card-content class="sales-mapping-section">
                  <div class="sales-section-inner">
                  <div class="sales-mapping-header">
                    <span class="sub-tab-section-title">Business Segment Wise Sales &amp; CS Mapping</span>
                    <div class="sales-header-actions">
                      <button mat-icon-button type="button" *ngIf="!disableSubmit"
                              (click)="addSalesMapping()"
                              matTooltip="Add row" class="sales-add-btn">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="sales-table-wrapper">
                    <table class="sales-table">
                      <thead>
                        <tr>
                          <th>Business Segment</th>
                          <th>Sales Person</th>
                          <th>Customer Support</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of salesMappings.controls; let i = index"
                            [formGroup]="$any(row)">
                          <td>
                            <mat-form-field appearance="fill" class="sales-field">
                              <mat-select formControlName="businessSegmentId" placeholder="Select"
                                          (selectionChange)="onBusinessSegmentChange(i, $event)">
                                <mat-option *ngFor="let seg of businessSegmentList" [value]="seg.id">
                                  {{seg.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="row.get('businessSegmentId').touched && row.get('businessSegmentId').hasError('required')">
                                Business Segment is required
                              </mat-error>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field appearance="fill" class="sales-field"
                                            [matTooltip]="row.get('salesPersonName').value">
                              <mat-select formControlName="salesPersonId" placeholder="Select"
                                          (selectionChange)="onSalesPersonChange(i, $event)">
                                <mat-option>
                                  <ngx-mat-select-search [searching]="searching" [formControl]="salesPersonSearchCtrl"
                                      noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Sales Person">
                                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option [value]="null">-- None --</mat-option>
                                <mat-option *ngFor="let emp of filteredSalesPerson | async" [value]="emp.id">
                                  {{emp.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field appearance="fill" class="sales-field"
                                            [matTooltip]="row.get('customerSupportName').value">
                              <mat-select formControlName="customerSupportId" placeholder="Select"
                                          (selectionChange)="onCustomerSupportChange(i, $event)">
                                <mat-option>
                                  <ngx-mat-select-search [searching]="searching" [formControl]="customerSupportSearchCtrl"
                                      noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Customer Support">
                                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option [value]="null">-- None --</mat-option>
                                <mat-option *ngFor="let emp of filteredCustomerSupport | async" [value]="emp.id">
                                  {{emp.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td class="sales-action-cell">
                            <span class="__action_delete_icon"
                                  (mousedown)="removeSalesMapping(i); $event.preventDefault()"
                                  *ngIf="!disableSubmit" matTooltip="Remove row">
                              <mat-icon>delete</mat-icon>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </mat-card-content>
                </mat-tab>

                <!--Sub-tab 2: Branch Tax & Credit Details -->
                <mat-tab label="Branch Tax & Credit Details">
                    <mat-card-content>
                        <app-branch-gst-details [buttonHidden]="true" [branchId]="id" [skipFetch]="true"
  [branchApiData]="branchApiData" [sharedSegments]="sharedCompanySegments"
  [sharedCurrencies]="sharedCurrencyList" [disableTable]="disableSubmit"
  [customerFlag]="_customerFlag"
  [vendorFlag]="_vendorFlag"
  [entityCustomerCurrencyId]="customerCreditCurrencyId"
  [entityCustomerCurrencyName]="customerCreditCurrencyName"
  [entityVendorCurrencyId]="vendorCreditCurrencyId"
  [entityVendorCurrencyName]="vendorCreditCurrencyName"
  (branchCreditAmountChanged)="branchCreditAmountChanged.emit()"></app-branch-gst-details>
                    </mat-card-content>
                </mat-tab>

                <!--Sub-tab 3: Branch Contact Details-->
                <mat-tab label="Branch Contact Details">
                    <mat-card-content>
                        <app-branch-contact [buttonHidden]="true" [branchId]="id" [skipFetch]="true"
  [disableTable]="disableSubmit" [branchApiData]="branchApiData" [sharedSegments]="sharedCompanySegments"
  [sharedDialCodes]="sharedDialCodesList"></app-branch-contact>
                    </mat-card-content>
                </mat-tab>

                <!--Sub-tab 4: Branch KYC Details-->
                <mat-tab label="Branch KYC Details">
                    <mat-card-content>
                        <app-kyc-details [countryId]="countryId" [buttonHidden]="true" [referenceName]="'Entity_Branch_KYC'"
                            [dataById]="idToKYC" [disableTable]="disableSubmit">
                        </app-kyc-details>
                    </mat-card-content>
                </mat-tab>

                <!--Sub-tab 5: Customer Portal Login Details-->
                <mat-tab label="Customer Portal Login Details" style="display:none" *ngIf="false">
                    <mat-card-content>
                        <div class="portal-table-wrapper">
                            <div class="portal-add-btn-row">
                                <button mat-icon-button type="button"
                                        (click)="addPortalUser()" [disabled]="disableSubmit"
                                        matTooltip="Add Portal User" class="portal-add-btn-inline">
                                    <mat-icon>add_box</mat-icon>
                                </button>
                            </div>
                            <table class="portal-table">
                                <thead>
                                    <tr>
                                        <th>User Name</th>
                                        <th>Email id</th>
                                        <th>Password</th>
                                        <th>Access</th>
                                        <th>Deactivate</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of customerPortalLogins.controls; let i = index"
                                        [formGroup]="$any(row)">
                                        <td>
                                            <mat-form-field appearance="fill" class="portal-field">
                                                <input matInput formControlName="userName"
                                                       placeholder="User Name" maxlength="50"
                                                       (blur)="trimControl(row.get('userName'))">
                                                <mat-error *ngIf="row.get('userName').hasError('pattern')">
                                                    Alphanumeric and underscore only
                                                </mat-error>
                                                <mat-error *ngIf="row.get('userName').hasError('maxlength')">
                                                    Max 50 characters
                                                </mat-error>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="fill" class="portal-field">
                                                <input matInput formControlName="emailId"
                                                       placeholder="Email ID" maxlength="100"
                                                       (blur)="trimControl(row.get('emailId'))">
                                                <mat-error *ngIf="row.get('emailId').hasError('email')">
                                                    Invalid email format
                                                </mat-error>
                                                <mat-error *ngIf="row.get('emailId').hasError('maxlength')">
                                                    Max 100 characters
                                                </mat-error>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="fill" class="portal-field">
                                                <input matInput [type]="passwordVisible[i] ? 'text' : 'password'" formControlName="password"
                                                       placeholder="Password" autocomplete="new-password"
                                                       (blur)="trimControl(row.get('password'))">
                                                <mat-icon matSuffix class="__show_psw" style="cursor:pointer; color:#b1b1b1;"
                                                          (click)="passwordVisible[i] = !passwordVisible[i]"
                                                          [matTooltip]="passwordVisible[i] ? 'Hide password' : 'Show password'">
                                                    {{ passwordVisible[i] ? 'visibility' : 'visibility_off' }}
                                                </mat-icon>
                                                <mat-error *ngIf="row.get('password').hasError('minlength')">
                                                    Min 8 characters required
                                                </mat-error>
                                                <mat-error *ngIf="row.get('password').hasError('pattern') && !row.get('password').hasError('minlength')">
                                                    Must have upper, lower, number &amp; special char
                                                </mat-error>
                                                <mat-hint *ngIf="row.get('id')?.value">Leave blank to keep current password</mat-hint>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="fill" class="portal-field portal-field--access">
                                                <mat-select formControlName="accessLevel">
                                                    <mat-option *ngFor="let lvl of accessLevelList"
                                                                [value]="lvl.key">
                                                        {{lvl.label}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                        <td class="portal-deactivate-cell">
                                            <mat-checkbox formControlName="isDeactivated"
                                                          matTooltip="When checked, user cannot login">
                                            </mat-checkbox>
                                        </td>
                                        <td class="portal-action-cell">
                                            <span class="__action_delete_icon"
                                                  (click)="removePortalUser(i)"
                                                  *ngIf="!disableSubmit"
                                                  matTooltip="Remove">
                                                <mat-icon>delete</mat-icon>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-tab>

            </mat-tab-group>
            </div><!-- end tab-group-wrapper -->
        </mat-card>

        <!--Branch Audit Log — its own "View Log" checkbox, scoped to this branch.
             Shown both standalone (edit/addBranch routes) and embedded in the Entity Form,
             so each branch tab in the Entity Form carries its own log rather than one
             combined panel at the bottom of that page. Wrapped in its own card (matching
             the branch-form-card above) so it doesn't look like a bare block floating
             outside the card layout. -->
        <mat-card class="branch-form-card audit-log-card" *ngIf="id">
          <mat-card-content>
            <app-audit-log-tabs [referenceId]="id" [referenceType]="'ENTITY_BRANCH'" [tabs]="auditLogTabs"></app-audit-log-tabs>
          </mat-card-content>
        </mat-card>

        <mat-card-actions *ngIf="!embedded" class="branch-form-actions">
            <button *ngIf="!disableSubmit" mat-button color="secondary" (click)="saveAsDraft()">SAVE AS DRAFT</button>
            <button *ngIf="!disableSubmit" mat-button color="primary" (click)="onSave()">SAVE</button>
            <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
        </mat-card-actions>
    </form>
</div>
